<template>
  <mad-lib-input
    :model-value="[modelValue]"
    :height="height"
    :format="format"
    :type-ahead-options="typeAheadOptions"
    :type-ahead-dropdown-height="typeAheadDropdownHeight"
    :placeholder="placeholder"
    :allow-empty-strings="allowEmptyStrings"
    single-input
    :disable-auto-focus="disableAutoFocus"
    :retain-value-on-focus="retainValueOnFocus"
    :fill-width="useFillWidth ? fillWidth : false"
    :taggify="taggify"
    :taggify-placeholder-text="taggifyPlaceholderText"
    :badgify="badgify"
    :can-create-aliases="canCreateAliases"
    :can-mark-as-required="canMarkAsRequired"
    :subtle="subtle"
    :textarea-rows="textareaRows"
    :character-limit="characterLimit"
    :length-error="lengthViolationMsg"
    :error="error"
    :disabled="disabled"
    :custom-text-formatter="customTextFormatter"
    :require-option="requireOption"
    :drop-down-right="dropDownRight"
    :text-variant="textVariant"
    :class="{ 'w-100 mw-100': useFillWidth && fillWidth }"
    :input-id="inputId"
    :type-ahead-loading="typeAheadLoading"
    :paging-size="pagingSize"
    :caret="caret"
    :block="block"
    :overflow-ellipsis="overflowEllipsis"
    :min-currency-value="minCurrencyValue"
    @type="$emit('type', $event)"
    @update:modelValue="update($event)"
    @focus="focus"
    @blur="blur"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]="slotData"
      :key="name"
    >
      <slot
        v-bind="slotData || {}"
        :name="name"
      />
    </template>
  </mad-lib-input>
</template>
<script>
import MadLibInput from 'core-ui/components/inputs/madLibInput.vue'
export default {
  // //////////////////////
  /// A wrapper that makes using the mad lib input component easy!
  // //////////////////////
  name: 'BasicMadLibInput',
  components: { MadLibInput },
  props: {
    modelValue: {
      type: [String, Number, Boolean, Object]
    },
    format: {
      type: String,
      default: 'TEXT'
    },
    textareaRows: {
      type: Number,
      default: 5
    },
    typeAheadOptions: {
      type: Array
    },
    typeAheadDropdownHeight: {
      type: String,
      default: '50vh'
    },
    placeholder: {
      type: String
    },
    height: {
      type: String,
      default: 'auto'
    },
    maxWidth: {
      type: String,
      default: 'none'
    },
    fillWidth: {
      type: Boolean,
      default: false
    },
    taggify: {
      type: Boolean,
      default: false
    },
    taggifyPlaceholderText: {
      type: Boolean,
      default: true
    },
    badgify: {
      type: Boolean,
      default: true
    },
    canCreateAliases: {
      type: Boolean,
      default: false
    },
    canMarkAsRequired: {
      type: Boolean,
      default: false
    },
    subtle: {
      type: Boolean,
      default: false
    },
    characterLimit: {
      type: Number,
      default: 0
    },
    allowEmptyStrings: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customTextFormatter: {
      type: Function
    },
    retainValueOnFocus: {
      type: Boolean,
      default: true
    },
    requireOption: {
      type: Boolean,
      default: false
    },
    disableAutoFocus: {
      type: Boolean,
      default: true
    },
    dropDownRight: {
      type: Boolean,
      default: false
    },
    textVariant: {
      type: String
    },
    inputId: {
      type: String
    },
    typeAheadLoading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    pagingSize: {
      type: Number
    },
    caret: {
      type: Boolean,
      default: false
    },
    block: {
      // show a MadLib in a t-form-group to look more like a traditional input (with possibility of using MadLib typeahead functionality)
      type: Boolean,
      default: false
    },
    overflowEllipsis: {
      type: Boolean,
      default: false
    },
    minCurrencyValue: {
      type: Number
    }
  },
  emits: ['update:value', 'update:modelValue', 'input', 'focus', 'blur'],
  data () {
    return {
      useFillWidth: false
    }
  },
  computed: {
    lengthViolationMsg () {
      if (this.characterLimit && this.characterLimit > 0 && this.modelValue) {
        const actualLength = this.$filters.evaluateLengthAfterInsertion(this.modelValue)
        if (typeof this.modelValue === 'string' && actualLength > this.characterLimit) {
          return `(${actualLength} / ${this.characterLimit})`
        }
      }
      return ''
    }
  },
  methods: {
    update ([value]) {
      this.$emit('update:modelValue', value)
    },
    focus () {
      this.useFillWidth = true
      this.$emit('focus')
    },
    blur () {
      this.useFillWidth = false
      this.$emit('blur')
    }
  }
}
</script>
